import http from "/src/httpRequest.js";
export default {
  actions: {
    async getContact(context) {
      const response = await http.get("contacts");
      context.commit("setContact", response.data);
    },
  },
};
